<template lang="pug">
  .information-form(v-loading="loading")
    company-info(:data="info" ref="company")
    contact-info(:data="info" ref="contact")
    exp-awards(:data="info" ref="expAwards")
    .information-general__buttons
      footer-button(
        :confirmButton="$t('保存')"
        @confirm="submit"
        @cancel="$router.push('/information/view/basic-info')"
      )
</template>

<script>
import axios from 'axios'
import ContactInfo from './ContactInfo'
import CompanyInfo from './CompanyInfo'
import ExpAwards from './ExpAwards'
import { format4backend } from '@/umcc/util'
import { flatten } from 'lodash'
import FooterButton from '@/components/FooterButton'

export default {
  components: {
    ContactInfo,
    CompanyInfo,
    ExpAwards,
    FooterButton
  },
  data () {
    return {
      loading: false,
      info: {}
    }
  },
  computed: {
    user () {
      return this.$store.getters.user
    }
  },
  mounted () {
    this.fetchInfo()
  },
  methods: {
    async fetchInfo () {
      this.loading = true
      try {
        const res = await axios.get('/vendor/vendor/getBasicInfo', {
          params: { vendor_id: this.user.struct_group_id }
        })
        this.info = this.normalizeData(res)
        this.loading = false
      } catch (error) {
        this.loading = false
        throw error
      }
    },
    normalizeData (res) {
      return {
        ...res.basic,
        category: res.category,
        ...res.company_information,
        ...res.contact_information,
        ...res.user,
        ...res.experience_award
      }
    },
    async submit () {
      this.loading = true
      try {
        const [company, contact, expAwards] = await Promise.all([
          this.$refs.company.submit(),
          this.$refs.contact.submit(),
          this.$refs.expAwards.submit()
        ])
        await axios.post('/vendor/vendor/updateVendor', format4backend(this.composeParams(company, contact, expAwards)))
        this.$message.success(this.$t('编辑成功'))
        const res = await axios.get('/vendor/vendor/getUserCompletedStatus')
        const user = this.$store.getters.user
        user.is_completed = res.is_completed
        this.$store.commit('common/setUser', user)
        this.loading = false
        this.$router.push('/information/view/basic-info')
      } catch (error) {
        if (error.message) {
          this.$message.error(error.message)
        }
        this.loading = false
      }
    },
    composeParams (company, contact, expAwards) {
      return {
        vendor: {
          vendor_name: company.vendor_name,
          vendor_name_ch: company.vendor_name_ch,
          is_total_vendor: company.is_total_vendor,
          vendor_internal_id: company.vendor_internal_id,
          website_url: company.website_url,
          company_logo: company.company_logo,
          weibo_qr_code: company.weibo_qr_code,
          wechat_qr_code: company.wechat_qr_code,
          parent_company: company.parent_company,
          parent_company_name: company.parent_company_name,
          company_type: company.company_type,
          company_size: company.company_size,
          establish_time: company.establish_time,
          city: company.city,
          address: company.address,
          zip_code: company.zip_code,
          telephone: company.telephone,
          company_introduction: company.company_introduction
        },
        vendor_contact: {
          email: contact.mail,
          name: contact.user_name,
          gender: contact.gender,
          title: contact.position,
          phone_mobile: contact.phone_mobile,
          phone_office: contact.phone_office
        },
        vendor_qualification: company.qualification
          .map(item => ({
            qualification_type: item.name,
            qualification_path: item.path
          }))
          .filter(item => item.qualification_path !== ''),
        vendor_experience: flatten(expAwards.experience.map(item => {
          const seqs = [1, 2, 3]
          if (item.id == null) return []
          return seqs
            .map(s => ({
              industry_id: item.id,
              seq: s,
              client_name: item[`client${s}`]
            }))
            .filter(item => item.client_name !== '')
        })),
        vendor_award: expAwards.award.filter(item => item.path).map(r => {
          return {
            award_path: r.path,
            award_name: r.award_name != null ? r.award_name : ''
          }
        })
      }
    }
  }
}
</script>

<style lang="stylus">
.information-form
  .el-input
    width 180px
  .el-button:not(.is-circle, .el-button--text)
    padding 4px 28px

.information-general__buttons
  display flex
  justify-content center
</style>
